import { IconWrapper } from '../runtime';
export default IconWrapper('company-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M2.37873 4.67093L13.5 0V24H3.25C2.00736 24 1 22.9926 1 21.75V6.74539C1 5.83939 1.54341 5.02177 2.37873 4.67093Z",
      "fill": "#00DDFF"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.37873 4.67093L13.5 0V24H3.25C2.00736 24 1 22.9926 1 21.75V6.74539C1 5.83939 1.54341 5.02177 2.37873 4.67093Z",
      "fill": 'url(#' + props.id + '325287f0' + ')',
      "fill-opacity": "0.3"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.37873 4.67093L13.5 0V24H3.25C2.00736 24 1 22.9926 1 21.75V6.74539C1 5.83939 1.54341 5.02177 2.37873 4.67093Z",
      "fill": 'url(#' + props.id + '8a873156' + ')',
      "fill-opacity": "0.4"
    }
  }), h("path", {
    "attrs": {
      "d": "M21.4275 7.50344L13.5 5V24H20.75C21.9926 24 23 22.9926 23 21.75V9.649C23 8.66737 22.3636 7.79904 21.4275 7.50344Z",
      "fill": 'url(#' + props.id + '37d3fffd' + ')'
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '325287f0',
      "x1": "0.706292",
      "y1": "8.42552",
      "x2": "11.7709",
      "y2": "17.5132",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#E2FF24"
    }
  }), h("stop", {
    "attrs": {
      "offset": "0.246334",
      "stop-color": "#BDFF24"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#00DFFF",
      "stop-opacity": "0.01"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '8a873156',
      "x1": "16.1143",
      "y1": "13.619",
      "x2": "4.27058",
      "y2": "6.32195",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#0700FF",
      "stop-opacity": "0.8"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#00FFF8",
      "stop-opacity": "0.01"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '37d3fffd',
      "x1": "14.125",
      "y1": "7.5",
      "x2": "14.125",
      "y2": "20.2895",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#0087F5"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#024DCE"
    }
  })])])]);
});